module.exports = __webpack_public_path__ + "static/media/logo_blue.7d334974.svg";